<template>
  <div class="audience">
    <template v-if="!loaded">
      <adx-loading-primary/>
    </template>
    <template v-else>
        <div class="audience__header">
      <div class="audience__header__left">
        <h1 class="large-font">{{campaignDetail.get_campaign_name}} </h1>
        <span class="small-font subtitle"> Campaign Period : {{displayPeriod(startDate, endDate)}}</span>
      </div>
    </div>
    <div class="impact">
      <div v-if="!isLoading" class="impact__content">
        <div class="impact__content--left">
          <div class="impact__content__campaignDetail">
            <div class="header title">
              <span class="subhead strong">Impact Report</span>
            </div>
            <div class="impact__content__campaignDetail__field__upload">
              <div class="div-wrapper">
                <div class="left">
                  <span class="filename" v-if="impactReportFileName">{{impactReportFileName}}</span>
                  <span v-else class="filename">Impact Report File_name.pdf</span>
                </div>
                <div class="right">
                  <input type="file" accept=".pdf" @change="getFile"
                  ref="fileUpload" style="display: none;">
                  <button
                    type="button" class="secondary btn-small btn-checkout-large" 
                     @click.stop="downloadUrl()">
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </template>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import Input from '@/components/Form/Input'
import lib from '@/lib/util'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate, dateFormat } from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-campaignreport-audience',
  components: {
    'adx-input': Input,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-secondary': LoadingSecondary,
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      campaignDetail: {},
      campaignName : null,
      impactReportFile: null,
      impactReportFileName: '',
      impactReportFileData: null,
      impactUrl : '',
      routeID: null,
      loaded: false,
      startDate: null,
      endDate: null,
      myRange: {
        start: null,
        end: null
      }
    }
  },
  computed: {

  },
  watch: {
    isImpression() {
      this.loadData()
    },
    myRange() {
      this.loadData()
    }
  },
  beforeCreate() {
    
  },
  created() {  
    if(this.$route.params.campaign_id){
      this.routeID = this.$route.params.campaign_id
    } 
  },
  beforeMount() {
    
  },
  mounted() {
    this.getUrl()
    this.loaded = true  
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    getFile(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.impactReportFile = e.target.result
        }
        reader.readAsDataURL(input.files[0]);
        this.impactReportFileName = input.files[0].name
        this.phoneNumbersFileData = input.files[0]
      }
    },
     getUrl() {
      (async() => {
        // this.downloadLoading = true
        const response1 = await api.get(apiV2.measurementImpact(this.routeID), {needToken: true})
    
        if(response1.status == 200){
          this.impactUrl = response1.data.impact_file
          if(this.impactUrl){
            this.impactReportFileName = this.impactUrl.split('/').pop()
          }
            this.campaignDetail.get_campaign_name = response1.data.get_campaign_name
            this.startDate = response1.data.get_start
            this.endDate = response1.data.get_end
            this.isLoaded = true
  
        } 
      })();
    },
    downloadUrl(){
    this.$http.get(this.impactUrl, {responseType: 'arraybuffer'})
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/ptestdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.impactReportFileName 
        link.click()
      })
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>